
import {Options, Vue} from 'vue-class-component';
import {Watch} from "vue-property-decorator";

@Options({
  components: {}
})
export default class OfficeList extends Vue {
  private activeTab: 'netherlands' | 'international' = 'netherlands';

  private setActiveTab(value: 'netherlands' | 'international') {
    this.activeTab = value;
  }

  mounted() {
    this.updateEventListeners();
  }

  private async updateEventListeners() {
    // Wait for dom update
    await this.$nextTick();

    // Set new event listeners
    this.$el.querySelectorAll('.office-item').forEach((item: HTMLElement) => {
      const readMoreButton = item.querySelector('.office-item__show-more');

      if (!readMoreButton) return;

      readMoreButton.addEventListener('click', (e) => {
        const newLabel: string | undefined = (e.target as HTMLElement).dataset['labelChange'];
        if (newLabel) {
          const oldLabel: string = (e.target as HTMLElement).innerText;
          (e.target as HTMLElement).innerHTML = (e.target as HTMLElement).innerHTML.replace(oldLabel, newLabel);
          (e.target as HTMLElement).dataset['labelChange'] = oldLabel;
        }

        item.classList.toggle('office-item--extended');
      });
    });
  }

  @Watch('activeTab')
  onActiveTabChanged() {
    this.updateEventListeners();
  }
}
